@if (creditIncreaseService.isLoading | async) {
  <div class="divLoading">
    <div class="backdrop"></div>
    <img src="assets/loader.gif" alt="loading..." />
  </div>
}
